"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Geocoder für GeoCMS-Verortungsdienste.
 *
 * @class
 * @extends gc.gis.module.GCLocator.AbstractGeocoder
 * @memberof gc.gis.module.GCLocator
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen. Siehe {@link gc.gis.module.GCLocator.AbstractGeocoder}
 */
gc.gis.module.GCLocator.Geocoder = function( options )
{
	gc.gis.assert.isSet( options );
	gc.gis.assert.isSet( options.id );

	gc.gis.module.GCLocator.AbstractGeocoder.call( this, options );
};
gc.gis.module.GCLocator.Geocoder.prototype = Object.create( gc.gis.module.GCLocator.AbstractGeocoder.prototype );

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.Geocoder.prototype._renderResultList = function( self, control, items, opt_show_list )
{
	// Alte Ergebnisse entfernen
	var list = control._element_list;
	list.children().remove();

	// Ausgabe
	for( var i=0; i<items.length; i++ )
	{
		var li = jQuery('<li>', {
			html: self.__renderResultItem( self, control, items[i] )
		});
		list.append( li );
	}

	// Keine Ergebnisse
	if( items.length === 0 )
	{
		list.append( jQuery('<li>', {
			'class': 'empty',
			text: 'Keine Ergebnisse'
		}) );
	}
	// Ggf. Liste anzeigen
	if( opt_show_list )
	{
		list.show('fade');
	}
};

/**
 * @private
 * @method
 *
 * @param {gc.gis.module.GCLocator.Geocoder} self this
 * @param {Object} control Control-Referenz
 * @param {Object} result Ergebnisobjekt
 */
gc.gis.module.GCLocator.Geocoder.prototype.__renderResultItem = function( self, control, result )
{
	var btn = jQuery('<a>', {
		href: '#',
		'class': '',
		html: '<span>'+ result.title +'</span>'
	});
	btn.on('click', function( evt ) {
		evt.preventDefault();
		try
		{
			control._element_input.val( result.title );
            control._element_input.data('identifier', result.identifier);
			control._element_list.hide('fade');

			var start_reset = false;
			for( var i=0; i<self.controls.length; i++ )
			{
				if( self.controls[i] === control )
				{
                    start_reset = true;		// Vorgänger-Eingabefelder zurücksetzen
					self._geocode( self, i, true );
					continue;
				}

				if( start_reset === true )
				{
					self._resetControls( i );
					break;
				}
			}
		}
		catch( err )
		{
			gc.gis.iface.log.error( self, err );
		}
		return false;
	});

	return btn;
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.Geocoder.prototype._showOnMap = function (result_item)
{
    if (result_item.geometry) {
        var old_scale = this.map.getScale();
        var position, extent;

        if (result_item.geometry.wkt)
        {
	        var options = {
		        projection: result_item.geometry.crs,
		        style: gc.gis.iface.styleFactory.getStyle(gc.gis.factory.StyleType.GEOCODE),
		        styleActive:  gc.gis.iface.styleFactory.getStyle(gc.gis.factory.StyleType.GEOCODE_ACTIVE)
	        };

	        // Markerposition wird recht komfortabel clientseitig berechnet und sollte stets dem gleichen Algorithmus folgen
	        // if (result_item.geometry.location)
	        // {
		     //    options.markerPosition = [
			 //        result_item.geometry.location.x,
			 //        result_item.geometry.location.y
		     //    ];
		     //    options.markerProjection = result_item.geometry.location.crs || result_item.geometry.crs;
	        // }

	        this.map.highlightGeometryWithMarker(
		        result_item.geometry.wkt,
		        this.output_format,
		        result_item.formatted_address || result_item.title,
		        options
	        );
        }
        else if (result_item.geometry.location)
        {
            position = [
                result_item.geometry.location.x,
                result_item.geometry.location.y
            ];
            this.map.showMarker(result_item.formatted_address || result_item.title, position, {
            	projection: result_item.geometry.crs
            });
        }

	    if (result_item.geometry.extent)
	    {
            extent = [
                result_item.geometry.extent.minx,
                result_item.geometry.extent.miny,
                result_item.geometry.extent.maxx,
                result_item.geometry.extent.maxy
            ];
            if (extent[0] == extent[2] && extent[1] == extent[3])
            {
                if (!position) {
                    position = [extent[0], extent[1]];
                }
                extent = undefined;
            }
        }

        if (extent)
        {
            this.map.fitExtent(extent, {
            	projection: result_item.geometry.crs,
                constrain_resolution: true,
				minscale: Math.min(gc.gis.iface.ZOOM_TO_MINSCALE, old_scale)
            });
        }
        else if (position)
        {
            this.map.setViewport({
                projection: result_item.geometry.crs,
                position: position,
                scale: Math.min(gc.gis.iface.ZOOM_TO_MINSCALE, old_scale)
            });
        }
    }
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.Geocoder.prototype._validateControl = function( element_input, cur_control_index, max_control_index )
{
	if( cur_control_index === max_control_index )
	{
		return;
	}
	else if( element_input )
	{
		if( element_input.val().length === 0 )
		{
			element_input.parents('.form-group').addClass('has-error');
			throw new gc.gis.error.GCError('Eingabefeld ist leer');
		}
		if( element_input.val().length < this.autocomplete_length )
		{
			element_input.parents('.form-group').addClass('has-error');
			throw new gc.gis.error.GCError('Ungenügende Eingabe');
		}
        if (!element_input.data('identifier'))
		{
			element_input.parents('.form-group').addClass('has-error');
			throw new gc.gis.error.GCError('Nichts ausgewählt');
		}
		element_input.parents('.form-group').removeClass('has-error');
	}
	else
	{
		throw new gc.gis.error.GCError('Internal error: no control given');
	}
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.Geocoder.prototype._getQueryString = function( self, control_index, opt_detail_search )
{
	var params = {};
	params.id = self.id;
	params.crs = (self.crs || self.map.getProjection());

	if(opt_detail_search)
	{
		params.detailSearch = true;
	}

	for(var i = 0; i <= control_index; i++)
	{
		var input = self.controls[i]._element_input;
        var identifier = input.data('identifier');
        if (i <= control_index && identifier)
		{
			params[input.attr('name') + '_id'] = identifier;
		}
		params[input.attr('name')] = input.val();
	}

	return gc.gis.GCUrl.buildUrl(self.url, params);
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.Geocoder.prototype._parseGeocoderResults = function( data )
{
	if( data.status !== 'OK' )
	{
        throw new gc.gis.error.GCError(data.message || 'Internal error');
	}
	return data.resultList;
};

